<div class="flex flex-col">
  @for (message of messages(); track message; let first = $first) {
    <p-message (onClose)="markAsSeen(message)" [severity]="message.severity">{{message.detail}}</p-message>
  }
</div>
